<template>
  <div class="photopointAdd">
    <LoadingPlaceholder v-if="loading" />
    <form v-else>
      <div class="form-group">
        <h4 class="m-0 mt-3">
          {{ "Photopoint" }}
        </h4>
        <hr class="m-0 mb-3" />
        <label>{{ $t("locaion") }}</label>
        <select
          v-model="photopoint.locationId"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('Type') },
          ]"
        >
          <optgroup
            v-for="group in locationGroups"
            :key="`loc-group-${group.resortId}`"
            :label="group.label"
          >
            <option
              v-for="loc in group.locations"
              :key="`loc-spot-${loc.id}`"
              :value="loc.id"
            >
              {{ `Location ${loc.id}` }}
            </option>
          </optgroup>
        </select>
        <hr class="m-0 mb-3" />
        <label>Key</label>
        <input
          v-model="photopoint.key"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('Name') },
          ]"
          type="text"
        />
        <hr class="m-0 mb-3" />
        <label>{{ $t("resortSpotAndPhotopoint.displayName") }}</label>
        <input
          v-model="photopoint.name"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('DisplayName') },
          ]"
          type="text"
        />
        <hr class="m-0 mb-3" />
        <label>External ID</label>
        <input
          v-model="externalIdsString"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('DisplayName') },
          ]"
          type="text"
        />
        <small class="form-text text-muted">You can enter multiple IDs separated by commas.</small>
        <hr class="m-0 mb-3" />
        <label>SVG Template Name</label>
        <input
          v-model="photopoint.attributes.svg_template_name"
          :class="[
            'form-control',
            { 'is-invalid': $validator.errors.has('DisplayName') },
          ]"
          type="text"
        />
        <hr class="m-0 mb-3" />
        <label>{{ $t("visible") }}</label>
        <input
          v-model="photopoint.visible"
          type="checkbox"
          class="ml-3"
        />
        <div class="m-0 mb-3" />
        <label>{{ $t("active") }}</label>
        <input
          v-model="photopoint.active"
          type="checkbox"
          class="ml-3"
        />
      </div>
      <LoadingPlaceholder v-if="upsertLoading" />
      <button
        v-else
        class="btn btn-primary float-right"
        :disabled="!photopoint.displayName || !photopoint.name"
        @click.prevent="addPhotopoint()"
      >
        <font-awesome-icon
          class="mr-2"
          icon="check"
        />{{ $t("add") }}
      </button>
      <div class="clearfix" />
    </form>
  </div>
</template>

<script>
import { errorMixin } from "@/mixins/errorMixin.js";

export default {
  name: "PhotopointAdd",
  mixins: [errorMixin],
  props: {
    resortId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      upsertLoading: false,
      locations: [],
      photopoint: {
        externalIds: [],
        attributes: {
          svg_template_name: "",
        },
      },
    };
  },
  computed: {
    locationGroups() {
      const groups = {};
      (this.locations || []).forEach((loc) => {
        const resortId = loc.resortId || this.resortId;
        if (!groups[resortId]) {
          groups[resortId] = [];
        }
        groups[resortId].push(loc);
      });
      return Object.keys(groups)
        .map((id) => ({
          resortId: Number(id),
          label: `Resort ${id}`,
          locations: groups[id],
        }))
        .sort((a, b) => a.resortId - b.resortId);
    },
    externalIdsString: {
      get() {
        if (this.photopoint.externalIds) {
          return this.photopoint.externalIds.join(",");
        }
        return "";
      },
      set(val) {
        this.photopoint.externalIds = val
          .split(",")
          .map((x) => x.trim());
      },
    },
  },
  created() {
    this.getLocations();
  },
  methods: {
    getLocations() {
      this.loading = true;
      this.axios
        .get(`/Resort/GetResortLocations?resortId=${this.resortId}&includeSharedResorts=true`)
        .then((response) => {
          this.locations = response.data;
          this.loading = false;
        });
    },
    async addPhotopoint() {
      this.upsertLoading = true;
      this.photopoint.externalIds = (this.photopoint.externalIds || []).filter(
        (x) => x && x.length > 0
      );
      this.photopoint.resortId = this.resortId;
      this.photopoint.typeId = 21;
      await this.axios
        .post("/Resort/CreatePhotopointForResort", this.photopoint)
        .then(() => {
          this.$snotify.success(
            this.$t("resortSpotAndPhotopoint.addedSuccessfullyPhotopoint")
          );
          this.$emit("reload");
          this.error_clear();
          this.upsertLoading = false;
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    },
  },
};
</script>

<style scoped>
.photopointAdd .progress {
  display: flex;
  flex: 1 1 auto;
  width: 1%;
  height: 20px;
  font-size: 1rem;
}
</style>
